import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {fuseAnimations} from 'fuseui';
import {FuseAlertType} from 'fuseui';
import {AuthService} from '../auth.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'auth-sign-up',
    templateUrl: './sign-up.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class AuthSignUpComponent implements OnInit {

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: ''
    };

    signUpForm!: FormGroup;
    showAlert = false;
    public viewDate = new Date();

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private translateService: TranslateService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Create the form
        this.signUpForm = this._formBuilder.group({

            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.pattern('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$')]],
            passwordConfirmation: ['', [Validators.required]],
            phone: ['', Validators.pattern('^[0-9]{9}$')],
            invoiceCountry: [''],
            invoiceCity: [''],
            invoiceStreet: [''],
            invoiceZip: [''],
            idNumber: [''],
            companyName: ['Testová firma']
        }, {validator: this.checkPasswords});
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    checkPasswords(group: FormGroup) {
        const pass = group.controls.password.value;
        const confirmPass = group.controls.passwordConfirmation.value;
        group.controls['passwordConfirmation'].setErrors(pass === confirmPass
            ? group.controls['passwordConfirmation'].errors : {notSame: true});
        return pass === confirmPass ? null : {notSame: true};
    }

    /**
     * Sign up
     */
    signUp(): void {
        // Do nothing if the form is invalid
        if (this.signUpForm.invalid) {
            return;
        }

        this.signUpForm.controls['companyName'].setValue('Testová firma');
        this.signUpForm.controls['idNumber'].setValue('');

        // Disable the form
        this.signUpForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Sign up
        this._authService.signUp(this.signUpForm.value)
            .subscribe(
                (response) => {

                    // Navigate to the redirect url
                    this._router.navigateByUrl('/confirmation-required');
                },
                (response) => {

                    // Re-enable the form
                    this.signUpForm.enable();

                    if (response?.error?.error) {
                        this.alert = {
                            type: 'error',
                            message: response?.error?.error,
                        };
                    } else {
                        // Set the alert
                        this.alert = {
                            type: 'error',
                            message: this.translateService.instant('auth.signup.error'),
                        };
                    }

                    // Show the alert
                    this.showAlert = true;
                }
            );
    }
}
